import React from 'react';
import { BrushControls } from './BrushControls';
import { ImageControls } from './ImageControls';
import { ActionButtons } from './ActionButtons';
import { Divider } from "@nextui-org/divider";

interface ControlPanelProps {
  controlsHeight: number;
  isImageLoaded: boolean;
  brushSize: number;
  setBrushSize: (size: number) => void;
  handleUndo: () => void;
  handleClearAll: () => void;
  handleZoomIn: () => void;
  handleZoomOut: () => void;
  toggleMode: () => void;
  mode: 'draw' | 'pan';
  handleClearCanvas: () => void;
  handleGenerateImage: () => void;
  isGenerating: boolean;
  handleDownload: () => void;
  lines: any[];
}

export const ControlPanel: React.FC<ControlPanelProps> = ({
  controlsHeight,
  isImageLoaded,
  brushSize,
  setBrushSize,
  handleUndo,
  handleClearAll,
  handleZoomIn,
  handleZoomOut,
  toggleMode,
  mode,
  handleClearCanvas,
  handleGenerateImage,
  isGenerating,
  handleDownload,
  lines
}) => {
  const brushControlsProps = {
    brushSize,
    setBrushSize,
    handleUndo,
    handleClearAll,
    isImageLoaded,
    lines
  };

  const imageControlsProps = {
    handleZoomIn,
    handleZoomOut,
    toggleMode,
    mode,
    handleClearCanvas,
    isImageLoaded
  };

  const actionButtonsProps = {
    handleGenerateImage,
    isGenerating,
    handleDownload,
    isImageLoaded
  };

  return (
    <div className="absolute bottom-0 left-0 right-0 p-4 bg-white bg-opacity-80" style={{ minHeight: `${controlsHeight}px` }}>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <BrushControls {...brushControlsProps} />
        <Divider orientation="vertical" className="h-10 hidden sm:block" />
        <ImageControls {...imageControlsProps} />
        <Divider orientation="vertical" className="h-10 hidden sm:block" />
        <ActionButtons {...actionButtonsProps} />
      </div>
      {!isImageLoaded && (
        <div className="absolute inset-0 bg-gray-200 bg-opacity-50 backdrop-blur-sm z-10" />
      )}
    </div>
  );
};